/**
 * values for setting the 'filtering scope' in multi opt in form field
 */
import { locale } from './../../ModuleEditor/util/locale-wrapper';

const PROGRESSIVE_FILTER_SCOPE = {
  ACCOUNT:  'account',
  CAMPAIGN: 'campaign',
};

const PROGRESSIVE_FILTER_SCOPE_ALL = _.values(PROGRESSIVE_FILTER_SCOPE, 'value');

const PROGRESSIVE_FILTER_SCOPE_LIST = [
  {
    label:       locale('Any campaigns'),
    description: 'Hide when already answered as part of any campaign.',
    value:       PROGRESSIVE_FILTER_SCOPE.ACCOUNT,
  },
  {
    label:       locale('Current campaign'),
    description: 'Hide when already answered as part of the current campaign.',
    value:       PROGRESSIVE_FILTER_SCOPE.CAMPAIGN,
  },
];

const MULTI_OPT_IN_FILTER_SCOPE_LIST = [
  {
    label:       locale('All experiences (account-level)'),
    description: 'User opt-ins will be remembered across all experiences that use this scope.',
    value:       PROGRESSIVE_FILTER_SCOPE.ACCOUNT,
  },
  {
    label:       locale('Current experience'),
    description: 'User opt-ins will be remembered across multiple entries to the current experience.',
    value:       PROGRESSIVE_FILTER_SCOPE.CAMPAIGN,
  },
];

export {
  PROGRESSIVE_FILTER_SCOPE,
  PROGRESSIVE_FILTER_SCOPE_LIST,
  PROGRESSIVE_FILTER_SCOPE_ALL,
  MULTI_OPT_IN_FILTER_SCOPE_LIST,
};

export default PROGRESSIVE_FILTER_SCOPE;
